module.exports = __webpack_public_path__ + "img/2.9c774c4c.jpg";